import React from 'react';
import {
  Container,
  Typography,
  Box,
  Breadcrumbs,
  Link,
  Grid,
  Card,
  CardContent,
  Button,
  Stack,
} from '@mui/material';
import {
  NavigateNext as NavigateNextIcon,
  Assessment as AppraisalIcon,
  Home as HomeIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export const DeliverablesComposerPage: React.FC = () => {
  const navigate = useNavigate();

  const handleBreadcrumbClick = (event: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    event.preventDefault();
    navigate(path);
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{ mb: 2 }}
      >
        <Link
          color="inherit"
          href="/"
          onClick={(e) => handleBreadcrumbClick(e, '/')}
          sx={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline'
            }
          }}
        >
          <HomeIcon sx={{ mr: 0.5 }} fontSize="small" />
          Home
        </Link>
        <Typography color="text.primary">Deliverables</Typography>
      </Breadcrumbs>

      {/* Page Header */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 600,
            color: 'text.primary',
            mb: 1
          }}
        >
          Deliverables
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
        >
          Create and manage project deliverables
        </Typography>
      </Box>

      {/* Main Content */}
      <Grid container spacing={3}>
        {/* Appraisals Card */}
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Stack spacing={2}>
                <Box display="flex" alignItems="center" gap={2}>
                  <AppraisalIcon color="primary" fontSize="large" />
                  <Typography variant="h6" component="h2">
                    Appraisals
                  </Typography>
                </Box>

                <Typography variant="body2" color="text.secondary">
                  Manage and view property appraisals. Create new appraisals from properties or HubSpot deals.
                </Typography>

                <Box sx={{ pt: 1 }}>
                  <Button
                    variant="contained"
                    onClick={() => navigate('/appraisals')}
                    startIcon={<AppraisalIcon />}
                    fullWidth
                  >
                    Go to Appraisals
                  </Button>
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};
